import "core-js/modules/es6.object.define-property";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}; // These LESS classes (and this file) are to be deprecated ASAP
// We shouldn't be relying on LESS classes.


import { createGlobalStyle } from 'styled-components';
export var GlobalDeprecatedStyles = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        /** @deprecated \u2013 use <Box> instead */\n        .stackable {\n            margin-bottom: 1rem;\n        }\n    "], ["\n        /** @deprecated \u2013 use <Box> instead */\n        .stackable {\n            margin-bottom: 1rem;\n        }\n    "])));
var templateObject_1;